var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('transition',{attrs:{"name":"epb-loading-mask--animated"}},[_c('section',{staticClass:"epb-loading-mask"},[_vm._t("default",function(){return [_c('EpbLoading',{staticClass:"epb-loading-mask__loading"})]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }